import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats';
import { formatDateStringIfMatches } from '../Utils/stringUtils';

const prepareServiceLines = (linesCollection, filterFunc) => linesCollection.values.filter(filterFunc).map(l => {
    return {
        lineId: !l.lineId && l.lineId !== 0 ? null : Number(l.lineId),
        revCode: l.revenueCode || null,
        procCode: l.procedureCode || null,
        serviceDate: formatDateStringIfMatches(l.serviceDate, DATE_STRING_FORMAT, API_DATE_STRING_FORMAT),
        modifier1: l.modifierOne || null,
        modifier2: l.modifierTwo || null,
        units: !l.units && l.units !== 0 ? null : l.units,
        billed: isNaN(l.billed) ? 0 : Number(l.billed)
    }
});

export default prepareServiceLines;
